export { ReactComponent as Artist } from './Artist.svg';
export { ReactComponent as RoyalArtist } from './RoyalArtist.svg';
export { ReactComponent as MasterAssistant } from './MasterAssistant.svg';
export { ReactComponent as CraftMaster } from './CraftMaster.svg';
export { ReactComponent as GrandMaster } from './GrandMaster.svg';